import React, { useState, useMemo, memo } from "react";
import styles from "./violazioneMaxPerditaMaxGuadagno.module.scss";
import { useTranslation } from "react-i18next";
import colorsStore from "shared/store/colorsStore";

type ViolazioneMaxPerditaMaxGuadagnoProps = {
  data: any;
  title: string;
};

const ViolazioneMaxPerditaMaxGuadagnoComponent: React.FC<
  ViolazioneMaxPerditaMaxGuadagnoProps
> = ({ data, title = "" }) => {
  // const dataTable =
  // data.analisi_backtest.rendimenti_cumulati_portafoglio_per_holding_period;

  const dataMaxPerdita =
    data.analisi_backtest.distribuzione_rendimenti_mensili_violazioni
      .max_perdita;

  const dataMaxGuadagno =
    data.analisi_backtest.distribuzione_rendimenti_mensili_violazioni
      .max_guadagno;

  // const outputData = [
  //   { key: "Min", label: "Min" },
  //   { key: "25 pct", label: "25° pct" },
  //   { key: "Median", label: "Mediana" },
  //   { key: "75 pct", label: "75° pct" },
  //   { key: "Max", label: "Max" },
  //   { key: "% Positive", label: "% periodi positivi" },
  // ];

  // let columnsNr = 0;
  // for (let mc in dataTable) {
  //   columnsNr++;
  //   for (let i = 0; i < dataTable[mc].length; i++) {
  //     const vv = outputData.find((o) => o.key === dataTable[mc][i].label);
  //     if (vv) {
  //       vv[mc] = dataTable[mc][i].weight;
  //     }
  //   }
  // }

  const [columns, setColumns] = useState(6);
  const totalRows = 2;
  const rows = [];

  for (let rowIndex = 0; rowIndex < totalRows; rowIndex++) {
    const row = rowIndex + 1;

    rows.push(row);
  }
  const cells = useMemo(() => {
    const generatedCells = [];
    for (const row of rows) {
      for (let colIndex = 0; colIndex < columns; colIndex++) {
        const cell = {
          row,
          col: colIndex + 1,
        };

        generatedCells.push(cell);
      }
    }

    return generatedCells;
  }, [rows, columns]);

  const getRenderedCells = (
    cells: { row: number; col: number }[],
    data: { label: string; weight: number }[],
    totalRows: number,
    styles: any,
  ) => {
    return cells.map((cell) => {
      const { row, col } = cell;

      if (row === 1) {
        return (
          <div
            key={`${row}-${col}`}
            className={[styles.cellViolazione, styles.productName].join(" ")}
          >
            {col > 1 && data[col - 2].label}
          </div>
        );
      }
      if (row === 2 && col === 1) {
        return (
          <div
            key={`${row}-${col}`}
            className={[
              styles.cellKeys,
              row === totalRows
                ? styles.cellWithNoBorder
                : styles.cellWithBorder,
            ].join(" ")}
            style={{ paddingBottom: 15 }}
          >
            {col === 1 && "PTF"}
          </div>
        );
      }
      if (row === 2) {
        return (
          <div
            key={`${row}-${col}`}
            className={[
              styles.cellKeysViolazione,
              row === totalRows
                ? styles.cellWithNoBorder
                : styles.cellWithBorder,
            ].join(" ")}
            style={{ paddingBottom: 15 }}
          >
            {col > 1 && data[col - 2].weight.toFixed(2)}
          </div>
        );
      }

      return (
        <div key={`${row}-${col}`} className={styles.cellValue}>
          -
        </div>
      );
    });
  };

  const renderedCellsPerdita = useMemo(() => {
    return getRenderedCells(cells, dataMaxPerdita, totalRows, styles);
  }, [cells, dataMaxPerdita, totalRows, styles]);
  const renderedCellsGuadagno = useMemo(() => {
    return getRenderedCells(cells, dataMaxGuadagno, totalRows, styles);
  }, [cells, dataMaxGuadagno, dataMaxPerdita, totalRows, styles]);

  return (
    <div>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.container}>
        <div className={`${styles.grid} ${styles[`grid${columns}`]}`}>
          {renderedCellsPerdita}
        </div>
      </div>
      <div className={styles.container} style={{ marginTop: 16 }}>
        <div className={`${styles.grid} ${styles[`grid${columns}`]}`}>
          {renderedCellsGuadagno}
        </div>
      </div>
    </div>
  );
};

export const ViolazioneMaxPerditaMaxGuadagno = memo(
  ViolazioneMaxPerditaMaxGuadagnoComponent,
  (prevProps, nextProps) => {
    return JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data);
  },
);

export default ViolazioneMaxPerditaMaxGuadagno;
